import { useEffect } from "react";

import AmplitudeProvider from "~/AmplitudeProvider";
import { useDigitalAssetTransfersController } from "./DigitalAssetTransfers.controller";
import { DigitalAssetTransfersPresentation } from "./DigitalAssetTransfers.pres";

export const DigitalAssetTransfersConnector = () => {
  const props = useDigitalAssetTransfersController();

  useEffect(() => {
    AmplitudeProvider.dispatchPageVisit();
    window.dispatchEvent(
      new CustomEvent("load", {
        detail: {
          "amplitude-event-name": "digital_asset_transfer_page_visited",
        },
      }),
    );
  }, []);

  return <DigitalAssetTransfersPresentation {...props} />;
};
